import _ from 'lodash';
import numeral from 'numeral';
import * as XLSX from "xlsx";
import { NORMAL_PROD, PROD_EX_SEND, PROD_GENERAL_JP_EX, PROD_SEND_JP_EX, STR_EMPTY, STR_ONE, STR_TWO, STR_ZERO } from './const';

//通貨書式設定 6000　⇒ ¥6,000
export function formatStringToCurrency(amount) {

  if (typeof amount === "undefined" || amount == '') {

    //return "¥0";
    return "0";

  } else {

    //return "¥" + moneyFormat(amount).toLocaleString("ja");
    return moneyFormat(amount).toLocaleString("ja");
  }

}

//通貨書式設定 2桁の小数
export function formatStringToWeight(amount) {

  if (typeof amount === "undefined" || amount == '') {

    //return "¥0";
    return "0";

  } else {

    //return "¥" + moneyFormat(amount).toLocaleString("ja");
    return moneyFormat(amount, 2).toLocaleString("ja");
  }

}

//¥6,000　⇒ 6000
export function formatCurrencyToNumber(amount) {

  if (typeof amount === "undefined") {
    return 0;
  }

  if (amount == "" || amount == null) {
    //return "";
    return 0;
  }

  if (typeof amount === "number") {
    return amount
  }

  //return Number(amount.replace(/[¥,]/g, ""));
  return Number(amount.replace(/[,]/g, ""));
}

//6000⇒6,000
//export function moneyFormat(amount, precision = 2, decimal = '.', thousands = ',') {
export function moneyFormat(amount, precision = 0, decimal = '.', thousands = ',') {
  if (amount != '' && amount !== null && amount != undefined && !isNaN(amount)) {
    const format = '0' + thousands && thousands + '0' + decimal + '0'.repeat(precision)
    return numberFormat(amount, format)
  }
  return amount
}

/**
 * number/money format
 * @param {number} amount oragin number
 * @param {number} format format string
 * @example
 * numberFormat(10000.456).format('0,0.00') => 10,000.46
 * numberFormat(10000.454).format('0.00') => 10000.45
 * numberFormat(10000.45).format('0') => 10000
 * numberFormat(10000.45).format('0,0') => 10,000
 */
export function numberFormat(amount, format = '0,0.00') {
  return numeral(amount).format(format)
}

//String⇒Date
export function formatStringToDate(dateString) {



  let dateFromYmd = new Date();

  //YYYY/MM/DD⇒Date
  if (typeof dateString === 'string' && /^\d{4}\/\d{2}\/\d{2}$/.test(dateString)) {

    const [year, month, day] = dateString.split('/');

    dateFromYmd = new Date(year, month - 1, day); // 注意月份是从0开始的

  } else if (typeof dateString === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(dateString)) {

    //YYYY-MM-DD⇒Date
    const [year, month, day] = dateString.split('-');

    dateFromYmd = new Date(year, month - 1, day); // 注意月份是从0开始的

  } else if (typeof dateString === 'string' && /^\d{8}$/.test(dateString)) {

    //YYYYMMDD⇒Date
    let year = parseInt(dateString.substring(0, 4), 10);

    let month = parseInt(dateString.substring(4, 6), 10) - 1; // 月份从0开始

    let day = parseInt(dateString.substring(6, 8), 10);


    dateFromYmd = new Date(year, month, day);

  } else {
    dateFromYmd = new Date();
  }

  if (isNaN(dateFromYmd.getTime())) {
    // console.log('Failed to create Date object from string.');
    dateFromYmd = new Date();
  }

  return dateFromYmd;

}


//日付フォーマット　Date⇒String(yyyy/MM/dd)
export function formatDateToString(value, pattern = 'yyyy/MM/dd') {
  let getDate = null
  if (value !== '' && value !== null && value !== undefined) {
    if (typeof value === 'string' && value.length === 8) {
      getDate = new Date(value.replace(/^(\d{4})(\d{2})(\d{2})$/, '$1/$2/$3'))
    } else {
      getDate = new Date(value)
    }
  } else {
    return value
  }

  const o = {
    'M+': getDate.getMonth() + 1,
    'd+': getDate.getDate(),
    'H+': getDate.getHours(),
    'm+': getDate.getMinutes(),
    's+': getDate.getSeconds(),
    'q+': Math.floor((getDate.getMonth() + 3) / 3)
    // S: getDate.getMilliseconds()
  }

  if (/(y+)/.test(pattern)) {
    const subStr = /(y+)/.exec(pattern)[1]
    pattern = pattern.replace(subStr, String(getDate.getFullYear()).slice(4 - subStr.length))
  }
  for (const key in o) {
    if (new RegExp('(' + key + ')').test(pattern)) {
      const subStr = new RegExp('(' + key + ')').exec(pattern)[1]
      pattern = pattern.replace(subStr, subStr.length === 1 ? o[key] : ('00' + o[key]).slice(String(o[key]).length))
    }
  }
  return pattern
}

//日付フォーマット　String(yyyy-MM-ddT00:00:00)⇒String(yyyy/MM/dd)
export function formatDateStrToString(value) {
  if (typeof value === 'string' && value.length === 19) {
    const parts = value.split('T')[0].split('-');
    return `${parts[0]}/${parts[1]}/${parts[2]}`;
  }
  else {
    return value;
  }
}

// ADD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 start↓
//日付フォーマット　String(yyyy/MM/dd)⇒String(yyyy/MM/dd)
export function formatDateToShortYear(value) {
  if (typeof value === 'string' && value.length === 10) {
    const parts = value.split('/'); // 文字列を'/'で分割
    if (parts.length === 3) {
      const year = parts[0].slice(-2); // 年の下位2桁を抽出
      return `${year}/${parts[1]}/${parts[2]}`; // yy/MM/dd形式を戻る
    }
  }
  return value; // フォーマットに一致する文字列でない場合は、そのまま元の値に戻る
}
// ADD 2025/03/19 ZLL 課題_受注データ取込のデータ列を調整 end↑

//1か月前の日付を取得 yyyy/MM/dd
export function getDateOneMonthAgo(date) {
  //年
  var year = date.getFullYear();
  //月(date.getMonth(): 0~11)
  var month = date.getMonth().toString();
  month = month.length > 1 ? month : "0" + month;
  //日
  var day = date.getDate().toString();
  day = day.length > 1 ? day : "0" + day;

  //日付=年/月/日(2024/06/07)
  return year + "/" + month + "/" + day;
}

//1か月前の日付を取得
export function getPreviousMonthDate(date) {

  var prevMonthDate = new Date(date);

  //1月前
  prevMonthDate.setMonth(prevMonthDate.getMonth() - 1);

  //現在日付 > 1月前日付の場合
  if (date.getDate() > prevMonthDate.getDate()) {
    // 前月の最終日に設定
    prevMonthDate.setDate(0);
  } else {
    // 前月の同じ日付に設定
    prevMonthDate.setDate(date.getDate());
  }

  return prevMonthDate;
}

//1か月前の日付を取得 yyyy/MM/dd
export function getOneMonthAgoArray() {

  const end = new Date();

  return [formatDateToString(getPreviousMonthDate(end)), formatDateToString(end)];

}

export function getNextMonthAgoArray() {

  const end = new Date();

  return [formatDateToString(end),formatDateToString(getNextMonthDate(end))];

}

//1か月後の日付を取得
export function getNextMonthDate(date) {

  var nextMonthDate = new Date(date);
  //1月後
  nextMonthDate.setMonth(nextMonthDate.getMonth() + 1);

  //現在日付 > 1月後日付の場合
  if (date.getDate() > nextMonthDate.getDate()) {
    // 後月の最終日に設定
    nextMonthDate.setDate(0);
  } else {
    // 後月の同じ日付に設定
    nextMonthDate.setDate(date.getDate());
  }

  return nextMonthDate;
}

// ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 start↓
// N月後の日付を取得
export function getNextNumMonthDate(date, num) {

  var nextMonthDate = new Date(date);
  //N月後
  nextMonthDate.setMonth(nextMonthDate.getMonth() + num);

  //現在日付 > N月後日付の場合
  if (date.getDate() > nextMonthDate.getDate()) {
    // 後月の最終日に設定
    nextMonthDate.setDate(0);
  } else {
    // 後月の同じ日付に設定
    nextMonthDate.setDate(date.getDate());
  }

  return nextMonthDate;
}
// ADD 2025/09/10 ZLL 課題_250905顧客からの改善したい点への対応 end↑


//1か月前の日付を取得 yyyy/MM/dd
export function getOneMonthAgo(date) {

  const datetime = date;
  datetime.setTime(datetime.getTime() - 3600 * 1000 * 24 * 30);

  return formatDateToString(datetime);
}

//日付を取得 yyyy/MM/dd
export function getCurrentDate(date) {
  //年
  var year = date.getFullYear();
  //月
  var month = (1 + date.getMonth()).toString();
  month = month.length > 1 ? month : "0" + month;
  //日
  var day = date.getDate().toString();
  day = day.length > 1 ? day : "0" + day;

  //日付=年/月/日(2024/07/07)
  return year + "/" + month + "/" + day;
}

//1か月後の日付の取得 yyyy/MM/dd
export function getDateOneMonthAfter(date) {
  //年
  var year = date.getFullYear();
  //月(date.getMonth(): 0~11)
  var month = (date.getMonth() + 2).toString();
  month = month.length > 1 ? month : "0" + month;
  //日
  var day = date.getDate().toString();
  day = day.length > 1 ? day : "0" + day;
   //日付=年/月/日(2024/87/07)
   return year + "/" + month + "/" + day;
}

//日付のnull処理 null⇒""の変換
export function dateNullToString(date) {

  if (date == null) {
    date = "";
  }

  return date;
}

//率書式設定(23⇒23%)
export function rateFormat(cellValue) {
   return cellValue + "%";
}

//日付フォーマット　String(yyyy-MM-ddT00:00:00)⇒String(yyyy/MM/dd)
export function formatDateyyyyMMdd(value) {
  if (typeof value === 'string' && value.length === 19) {
    const parts = value.split('T')[0].split('-');
    return `${parts[0]}${parts[1]}${parts[2]}`;
  }
  else {
    return value;
  }
}

// ADD 2024/12/16 Wjx (#32827)受注データ取込の検討と対応 start↓
//日付フォーマット　String(yyyy-MM-ddT00:00:00)⇒String(yyyy/MM/dd 00:00:00)
export function formatDateToyyyyMMddHHmmss(value) {
  if (typeof value === 'string' && value.length === 19) {
    value=value.replace(/-/g, ":").replace("T", ":");
    const parts = value.split(':');
    return `${parts[0]}/${parts[1]}/${parts[2]} ${parts[3]}:${parts[4]}:${parts[5]}`;
  }
  else {
    return value;
  }
}

//日付フォーマット　Date⇒String(yyyyMMdd_HHmmss、yyyy/MM/dd HH:mm:ss)
export function formatSystemTimeToyyyyMMddHHmmss(date,format) {
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  const hour = date.getHours().toString().padStart(2, '0');
  const minute = date.getMinutes().toString().padStart(2, '0');
  const second = date.getSeconds().toString().padStart(2, '0');

  if (format == "yyyyMMdd_HHmmss") {
    return `${year}${month}${day}_${hour}${minute}${second}`;
  }
  else if (format == "yyyy/MM/dd HH:mm:ss") {
    return `${year}/${month}/${day} ${hour}:${minute}:${second}`;
  }
  else {
    return date;
  }
}

//日付フォーマット　Date⇒String(yyyy/MM/dd)
export function formatDateStrToyyyyMMdd(value) {
  return value.toISOString().split("T")[0].replace(/[-]/g, "/");
}

// ADD 2024/12/16 Wjx (#32827)受注データ取込の検討と対応 end↑

//合計行データの計算
//totalColumns: 合計可能の列 currencyColumns:数字⇒通貨の変換列
export function calculateTotalData(param, totalColumns, currencyColumns) {
  //param意味がない場合は、合計処理を実施しない
  if (!param) {
    return;
  }

  const { columns, data } = param;

  const sums = [];
  columns.forEach((column, index) => {
    if (index === 0) {
      sums[index] = "合計";
      return;
    }

    if (totalColumns.includes(column.property)) {

      let values;

      //通貨⇒数字の変換
      if (currencyColumns.length != 0 && currencyColumns.includes(column.property)) {
        values = data.map((item) =>
          formatCurrencyToNumber(item[column.property])
        );
      } else {
        values = data.map((item) => item[column.property]);
      }

      //数値ではない、または数値に変換できない内容がある
      if (!values.every((value) => isNaN(value))) {
        //初期値：0
        sums[index] = values.reduce((prev, curr) => {
          const value = Number(curr);

          if (!isNaN(value) || value != 0) {
            return prev + curr;
          } else {
            return prev;
          }
        }, 0);

        //通貨の項目　数字⇒通貨の変換
        if (currencyColumns.length != 0 && currencyColumns.includes(column.property)) {
          sums[index] = formatStringToCurrency(sums[index]);
        }

        //合計結果が0の場合、空を表示する
        // if (sums[index] == 0) {
        //   sums[index] = "";
        // }

      } else {
        sums[index] = "";
      }
    }
  });

  return sums;
}

//日付変換　undefined/string ⇒Date　(画面表示用)
export function formatUndefinedToDate(date) {
  if (typeof date === "undefined") {
    return "";
  } else {
    return new Date(date);
  }
}

//日付変換　Date/null ⇒string (データ保存用)
export function formatCurDateToString(date) {
  if (dateNullToString(date) !== "") {
    return formatDateToString(date);
  } else {
    return "";
  }
}

// ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
// 課題_発送予定機能の追加
//日付変換　システム時間 ⇒　yyyy/MM/dd HH:mm
export function formatCurDateToYYYYMMddHHmm() {
  let currentDate = new Date();

  // 年、月、日、時間、分の取得
  let year = currentDate.getFullYear(); // 4桁の年を取得
  let month = String(currentDate.getMonth() + 1).padStart(2, '0'); // 月を取得し（0-11、1を追加必要）、ゼロを追加
  let day = String(currentDate.getDate()).padStart(2, '0'); //　取得日、ゼロの補足
  let hours = String(currentDate.getHours()).padStart(2, '0'); // 取得時間、ゼロの補足
  let minutes = String(currentDate.getMinutes()).padStart(2, '0'); // 取得分、ゼロの補足

  // 必要なフォーマットに分割
  let formattedDate = `${year}/${month}/${day} ${hours}:${minutes}`;
  return formattedDate
}
// ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑

// 運送状況の取得
export function GetTrStatus(trStatus) {
      switch (trStatus) {
        case "未運送":
          return "1";
        case "部分運送":
          return "2";
        case "運送済み":
          return "3";
        case "1":
          return "未運送";
        case "2":
          return "部分運送";
        case "3":
          return "運送済み";
        default:
          return "";
      }
}

//dialogの内容の高さ（基本情報 + 明細情報 + 合計情報）65 = 35(header) + 10(dialog_body padding) + 20(card_body padding)
export function getDialogContentHeight(dialogHeight, basicHeight, bottomHeight, resizeHeight) {
  // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
  // 画面と文字サイズの調整
  // return (dialogHeight * (1 - 0.1) - 65) - basicHeight - bottomHeight - resizeHeight;
  return (dialogHeight * (1 - 0.01) - 65) - basicHeight - bottomHeight - resizeHeight;
  // UPD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑

}

// ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
export function getDialogContentHeightComm(dialogHeight, basicHeight, bottomHeight, resizeHeight) {
  return (dialogHeight* (1 - 0.1) - 65) - basicHeight - bottomHeight - resizeHeight;
}
// ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑

//編集画面の列幅の取得
export function getEditColWidthArr(windowWidth, colKbn) {

  let colArr = {};

  //新しいパソコン
  if (windowWidth >= 1800) {
    if (colKbn == 3) {
      colArr.colL = 3;
      colArr.colR = 3;
    } else if (colKbn == 4 || colKbn == 5) {
      colArr.colL = 2;
      colArr.colR = 2;
    }
  }
  //古いパソコン
  else if (windowWidth >= 1400 && windowWidth < 1800) {
    if (colKbn == 3) {
      colArr.colL = 1;
      colArr.colR = 2;
    } else if (colKbn == 4 || colKbn == 5) {
      colArr.colL = 0;
      colArr.colR = 0;
    }
  }
  //ノートブックPC
  else {
    if (colKbn == 3 || colKbn == 4 || colKbn == 5) {
      colArr.colL = 0;
      colArr.colR = 0;
    }
  }

  // for (let index = 1; index <= colKbn; index++) {
  //   colArr[`col${index}`] = (24 - colArr.colL - colArr.colR) / colKbn;
  // }

  colArr.colCom = Math.ceil((24 - colArr.colL - colArr.colR) / colKbn);

  return colArr;
}

// 使用可能な担当者リストの取得
export function getAbleUserInfoList(userInfoList, userCode) {
  var ableUserList = userInfoList.filter(user => {
      // ユーザコードが等しい、または削除区分が1でない場合
      return (!isNaN(userCode) && user.UserId) === userCode || user.DeleteFlg === '0';
 });
  return ableUserList;
}

export function editUserInfoList(userInfoList, userCode, userCustomersList, cusCode) {

    const customerUserIds = userCustomersList
    .filter(customer => customer.ucCusCode === cusCode)
      .map(customer => customer.ucUserId);

var ableUserList = userInfoList.filter(user => {
  // 用户ID在customerUserIds中，并且用户未被标记为删除
  return customerUserIds.includes(user.UserId) &&(
         // 用户ID等于userCode（如果userCode是数字）
         (!isNaN(userCode) && user.UserId === userCode) ||
         // 用户未被标记为删除
         user.DeleteFlg === '0');
});

     return ableUserList;
}

// 使用可能な得意先担当者リストの取得
export function getAbleCusUserInfoList(cusUserInfoList, userCode) {
  var ableCusUserList = cusUserInfoList.filter(user => {
      // ユーザコードが等しい、または削除区分が1でない場合
      return (!isNaN(userCode) && user.mgrCode) === userCode || user.mgrDelFlag === '0';
 });
  return ableCusUserList;
}

// ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 start↓
// 使用可能な得意先納品先リストの取得
export function getAbleCusDeliveryList(cusDeliveryList, damCode) {
  var ableCusDeliveryList = cusDeliveryList.filter(dam => {
      // ユーザコードが等しい、または削除区分が1でない場合
      return (!isNaN(damCode) && dam.damCode) === damCode || dam.damDelFlag === '0';
 });
  return ableCusDeliveryList;
}
// ADD 2025/08/07 ZLL 課題_250725顧客からの改善したい点への対応 end↑

// ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 start↓
// 目的港の追加
// 使用可能な目的港リストの取得
export function getAbleDestinationList(destinationList, dpCode) {
  var ableDestinationList = destinationList.filter(dp => {
      // ユーザコードが等しい、または削除区分が1でない場合
      return (!isNaN(dpCode) && dp.dpCode) === dpCode || dp.dpDelFlag === '0';
 });
  return ableDestinationList;
}
// ADD 2026/04/20 ZLL 課題_顧客からの改善したい点への対応 end↑

// 使用可能な得意先リストの取得
export function getAbleCusMstInfoList(cusMstInfoList, cusCode) {
  var ableCusMstList;
  var endDate;
  // 得意先コードが空の場合
  if (!cusCode || cusCode === "") {
    ableCusMstList = cusMstInfoList.filter(cus => {
      // 使用終了日が現在の日付以上の場合
      endDate = new Date(cus.cusEndDate);
      return !isNaN(endDate) && endDate >= new Date();
    });
  } else {// 得意先コードが空しない場合
    ableCusMstList = cusMstInfoList.filter(cus => {
      endDate = new Date(cus.cusEndDate);
      // 得意先コードが等しい、または使用終了日が現在の日付以上の場合、リストを取得
      return cus.cusCode === cusCode || (!isNaN(endDate) && endDate >= new Date());
    });
  }
  return ableCusMstList;
}

// 使用可能な仕入先リストの取得
export function getAbleSupplierInfoList(supplierInfoList, supCode) {
  var ableSupplierList;
  var endDate;

  // 仕入先コードが空の場合
  if (!supCode || supCode === "") {
       ableSupplierList = supplierInfoList.filter(su => {
         endDate = new Date(su.supEndDate);

         // 使用終了日が現在の日付以上の場合
        return !isNaN(endDate) && endDate >= new Date();
      });
  } else {
    ableSupplierList = supplierInfoList.filter(su => {
      endDate = new Date(su.supEndDate);
      // 仕入先コードが等しい、または使用終了日が現在の日付以上の場合、リストを取得
          return (supCode === su.supCode|| (!isNaN(endDate) && endDate >= new Date()));
      });
  }

  return ableSupplierList;
}

export function cmpBasicData(cmpBasicData, updateBasicData) {

  if (_.isEqual(cmpBasicData, updateBasicData)) {

    return true;
  } else {

    return false;
  }
}

export function cmpDetailData(cmpDetailData, updateDetailData) {

  if (_.isEqual(cmpDetailData, updateDetailData)) {

    return true;
  } else {
    return false;
  }
}

// ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
export function cmpDetailDataExceptRemarks(cmpDetailData, updateDetailData, keysToIgnore=[]) {
  if (cmpDetailData === updateDetailData) return true;

  if (typeof cmpDetailData !== 'object' || typeof updateDetailData !== 'object')
    return cmpDetailData === updateDetailData;

  const keys1 = Object.keys(cmpDetailData).filter(k => !keysToIgnore.includes(k));
  const keys2 = Object.keys(updateDetailData).filter(k => !keysToIgnore.includes(k));

  if (keys1.length !== keys2.length) return false;

  return keys1.every(key =>
    cmpDetailDataExceptRemarks(cmpDetailData[key], updateDetailData[key], keysToIgnore)
  );
}
// ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑


// ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 start↓
// 課題_備考機能の追加
// 備考表示の変更
export function formatRemarksShow(value) {
  if (!value) {
    return value;
  }
  // ■で配列に分割
  const groups = value.split('■');
  // 分割数
  let splitNum = 50;

  // 各グループのデータの処理
  const processedGroups = groups.map(group => {
    let result = '';


    while (group.length > splitNum) {
      // 最初の分割数文字を切り取る
      result += group.substring(0, splitNum) + '<br />';
      // 残りは処理を続行
      group = group.substring(splitNum);
    }
    // 残りを追加
    result += group;
    return result;
  });

  // 区切り記号
  const separator = `<hr class="tooltip-separator" />`;

  // すべてのデータをセパレータで接続する
  return processedGroups.join(separator);
}

export function getIconType(remarks) {
      if (remarks) {
        return 'primary'; // コンテンツがある場合のアイコンクラス名
      } else {
        return 'info'; // コンテンツがない場合のアイコンクラス名
      }
}
// ADD 2025/04/16 ZLL 課題_250328~250416顧客からの改善したい点への対応 end↑

// ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 start↓
// 共通備考の調整（備考列幅の設定）
export function getRemarksColumnWidth(table) {


  //一覧表のデータが空です
  if (!table || table.length === 0) {
    return 80;
  }
  //一覧表のデータの全て備考が空です
  const hasAnyRemarks = table.some(
    (row) => (row.aodProdRemarksSum && row.aodProdRemarksSum.trim() )||(row.aodProdRemarks && row.aodProdRemarks.trim())
  );

  if (!hasAnyRemarks) {
    return 80;
  }
  //一覧表のデータの備考は20文字以上
  const hasLongRemarks = table.some(
    (row) =>
      (row.aodProdRemarksSum && row.aodProdRemarksSum.trim().length > 20)|| (row.aodProdRemarks && row.aodProdRemarks.trim().length > 20)
  );

  if (hasLongRemarks) {
    //最大20文字まで表示
    //text-width:12、cell-padding-left/right:10、button-width:32、between-width:10
    return 302; //302=20*12+10*2+32+10
  }
  //一覧表のデータの最大備考長さ
  const maxLength = table.reduce((maxLength, item) => {

    const value =
    (item["aodProdRemarksSum"] != undefined)
      ? (item["aodProdRemarksSum"])
      : (   item["aodProdRemarks"] != undefined?item["aodProdRemarks"]:"")
    const length = String(value).length;


    return length > maxLength ? length : maxLength;
  }, 0);


  //text-width:12、cell-padding-left/right:10、button-width:32、between-width:10
  return maxLength * 12 + 10 * 2 + 32 + 10;
}
// ADD 2025/06/10 Wjx 課題_250604顧客からの改善したい点への対応 end↑

// ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 start↓
// 課題_納期分割機能の追加
export function ShowMergeExKbn(prodExKbn, prodReceExKbn) {
  // 入荷異常区分が空のチェック
  // 入荷異常区分が空の場合、デファクト値が"0"を設定
  if (prodReceExKbn == null || prodReceExKbn == STR_EMPTY || prodReceExKbn == undefined) {
    prodReceExKbn = STR_ZERO;
  }

  //　正常品
  if (prodExKbn === STR_ZERO && prodReceExKbn === STR_ZERO) {
    return NORMAL_PROD; // 正常製品の表示値
  } else if (prodExKbn === STR_ZERO && prodReceExKbn === STR_ONE) {
    // 正常品の入荷異常品
    return PROD_GENERAL_JP_EX;
  } else if (prodExKbn === STR_TWO && prodReceExKbn === STR_ZERO) {
    // 納品異常品
    return PROD_EX_SEND;
  } else if (prodExKbn === STR_TWO && prodReceExKbn === STR_ONE) {
    // 納品異常品の入荷異常品
    return PROD_SEND_JP_EX;
  }
}
// ADD 2025/07/01 ZLL 課題_数量·納期調整機能の追加 end↑

// ADD 2025/08/21 WZC 課題_日本入荷の配送単導入機能の追加 start↓
// 共通方法：配送単読み取り
export function readZColumnFromXLSX(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (event) => {
      const data = new Uint8Array(event.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];

      const jsonDataWithHeader = XLSX.utils.sheet_to_json(sheet, {
        header: 1,
      });

      const zColumnValues = [];
      for (const rowKey in sheet) {
        if (rowKey.length > 1 && rowKey[0] === "Z" && rowKey[1] !== "Z") {
          const cellValue = sheet[rowKey].v
            ? sheet[rowKey].v
            : sheet[rowKey];
          zColumnValues.push(cellValue);
        }
      }

      const result = {
        jsonDataWithHeader: jsonDataWithHeader,
        zColumnValues: zColumnValues,
      };
      resolve(result);
    };
    reader.readAsArrayBuffer(file);
  });
}
// ADD 2025/08/21 WZC 課題_日本入荷の配送単導入機能の追加 end↑

